import ChecklistItemService from '@/service/checklist-item'
export default {
  getListChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.getListChecklistItem(payload.page, payload.per_page, payload.status, payload.search, payload.sort, payload.group).then(res => {
        commit('getListChecklistItem', res.data)
        resolve(res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.createChecklistItem(payload.checklist_item).then(res => {
        commit('createChecklistItem', res.data.data)
        resolve(res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  updateChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.updateChecklistItem(payload.checklist_item).then(res => {
        commit('updateChecklistItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.destroyChecklistItem(payload.checklist_item).then(res => {
        commit('destroyChecklistItem', res.data.data)
        resolve(res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  approvalChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.approvalChecklistItem(payload.checklist_item).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  rejectChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.rejectChecklistItem(payload.checklist_item).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  showChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.showChecklistItem(payload.checklist_item).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  uploadImage ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.uploadImage(payload.data).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  openEdit ({commit}, payload) {
    commit('openEdit')
  },
  closeEdit ({commit}, payload) {
    commit('closeEdit')
  },
  openCreateChildren ({commit}, payload) {
    commit('openCreateChildren')
  },
  closeCreateChildren ({commit}, payload) {
    commit('closeCreateChildren')
  },
  openView ({commit}, payload) {
    commit('openView')
  },
  closeView ({commit}, payload) {
    commit('closeView')
  },
  openChecklistItem ({commit}, payload) {
    commit('openChecklistItem')
  },
  closeChecklistItem ({commit}, payload) {
    commit('closeChecklistItem')
  },
  getReferDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.getReferDocument(payload.checklist_item).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  multiDestroyChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.multiDestroyChecklistItem(payload.ids).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  multiApprovalChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.multiApprovalChecklistItem(payload.ids).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  multiRejectChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.multiRejectChecklistItem(payload.ids).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  getHeaderChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ChecklistItemService.getHeaderChecklistItem(payload.group).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/checklist-item/actions.js